/* src/app/ships/round-trips/round-trips.component.css */
/*# sourceMappingURL=round-trips.component.css.map */
